/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import {
  Box, Tabs, Tab, Typography, Chip
} from '@mui/material';
import dayjs from 'dayjs';
import { useSnackbar } from 'notistack';
import * as hrAttendApi from '../../lib/api/hrAttend';
import AttendListTab from '../../components/attendancemng/AttendListTab';
import LeaveListTab from '../../components/attendancemng/LeaveListTab';
import LeaveRequestListTab from '../../components/attendancemng/LeaveRequestListTab';
import LeaveApprovalInboxTab from '../../components/attendancemng/LeaveApprovalInboxTab';
import WorkScheduleTab from '../../components/attendancemng/WorkScheduleTab';
import WorkScheduleRequestListTab from '../../components/attendancemng/WorkScheduleRequestListTab';
import WorkScheduleChangeRequestDialog from '../../components/attendancemng/WorkScheduleChangeRequestDialog';
import AttendInputModal from '../../components/attendancemng/AttendInputModal';
import LeaveInputModal from '../../components/attendancemng/LeaveInputModal';
import LeaveRequestModal from '../../components/attendancemng/LeaveRequestModal';
import LeaveRequestActionDialog from '../../components/attendancemng/LeaveRequestActionDialog';
import LeaveRequestDetailDialog from '../../components/attendancemng/LeaveRequestDetailDialog';
import BreadcrumbsContainer from '../common/breadcurmbs/BreadcrumbsContainer';
import { useLocation, useNavigate } from 'react-router-dom';

// bito 포팅(2026-10-19, ksm_backend 근태관리 기반) + 신규 휴가 2종.
//  - MATERNITY(출산휴가): 연차 차감 없음 (서버가 집계 쿼리에서 제외).
//  - ANNUAL_HOURLY(1시간 단위 연차): leaveHours(1시간 단위) + leaveStartTm 입력, 서버가
//    표준근무시간(기본 8h)으로 환산해 LEAVE_DAYS(소수)에 저장하고 연차 잔여일수에서 차감.
// 2026-10-22 B1: WorkSchedule(근무표/교대) 화면을 ksm_frontend에서 포팅(백엔드는 10-19에 이미
//  이식됨). KSM도 근무표 변경 요청을 ApprovalV2로 보내지 않고 HR/근태 권한자가 직접
//  확정/반려하는 단순 플로우라 bito도 동일하게 따른다(ApprovalCompletionHandler 불필요).
// ApprovalV2(결재선 템플릿/대결/최종결재자) 관리 화면은 bito에 그 엔진이 없어 제외 -
//  휴가 신청 시 결재자를 직접 1명 지정하는 단순 결재로 대체(COM_APPR_DET 재사용, 백엔드 참고).
export const LEAVE_TYPE_LABELS = {
  ANNUAL: '연차',
  ANNUAL_HOURLY: '연차(시간단위)',
  UNPAID: '무급 휴가',
  ABSENT: '무단 결근',
  EARLY_LEAVE: '조퇴',
  HALF_AM: '반차(오전)',
  HALF_PM: '반차(오후)',
  OVERTIME: '특근',
  BUSINESS: '출장',
  SICK: '병가',
  MATERNITY: '출산휴가',
};

export const LEAVE_TYPE_COLORS = {
  ANNUAL: 'success',
  ANNUAL_HOURLY: 'success',
  UNPAID: 'warning',
  ABSENT: 'error',
  EARLY_LEAVE: 'warning',
  HALF_AM: 'info',
  HALF_PM: 'info',
  OVERTIME: 'secondary',
  BUSINESS: 'default',
  SICK: 'primary',
  MATERNITY: 'secondary',
};

export const LEAVE_REQUEST_STATUS_LABELS = {
  IN_APPROVAL: '결재중',
  APPROVED: '승인완료',
  REJECTED: '반려',
  RECALLED: '회수',
  CANCELED: '취소',
};

export const LEAVE_REQUEST_STATUS_COLORS = {
  IN_APPROVAL: 'warning',
  APPROVED: 'success',
  REJECTED: 'error',
  RECALLED: 'default',
  CANCELED: 'default',
};

const AttendMngContainer = () => {
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();
  const navigate = useNavigate();

  const [tabIndex, setTabIndex] = useState(0);
  const [searchYm, setSearchYm] = useState(dayjs().format('YYYYMM'));
  const [searchUsrUuid, setSearchUsrUuid] = useState('');

  const [attendList, setAttendList] = useState([]);
  const [leaveList, setLeaveList] = useState([]);
  const [leaveRequestList, setLeaveRequestList] = useState([]);
  const [approvalInboxList, setApprovalInboxList] = useState([]);
  const [balance, setBalance] = useState(null);

  const [workShiftList, setWorkShiftList] = useState([]);
  const [workScheduleList, setWorkScheduleList] = useState([]);
  const [workScheduleRequestList, setWorkScheduleRequestList] = useState([]);
  const [workScheduleRequestInboxList, setWorkScheduleRequestInboxList] = useState([]);
  const [holidayList, setHolidayList] = useState([]);

  const [attendLoading, setAttendLoading] = useState(false);
  const [leaveLoading, setLeaveLoading] = useState(false);
  const [requestLoading, setRequestLoading] = useState(false);
  const [approvalLoading, setApprovalLoading] = useState(false);
  const [workScheduleLoading, setWorkScheduleLoading] = useState(false);
  const [workScheduleSaving, setWorkScheduleSaving] = useState(false);
  const [workScheduleRequestLoading, setWorkScheduleRequestLoading] = useState(false);
  const [workScheduleRequestInboxLoading, setWorkScheduleRequestInboxLoading] = useState(false);
  const [workScheduleRequestSaving, setWorkScheduleRequestSaving] = useState(false);
  const [holidayLoading, setHolidayLoading] = useState(false);
  const [holidaySaving, setHolidaySaving] = useState(false);

  const [attendModalOpen, setAttendModalOpen] = useState(false);
  const [leaveModalOpen, setLeaveModalOpen] = useState(false);
  const [leaveRequestModalOpen, setLeaveRequestModalOpen] = useState(false);
  const [workScheduleRequestModalOpen, setWorkScheduleRequestModalOpen] = useState(false);
  const [selectedAttend, setSelectedAttend] = useState(null);
  const [selectedLeave, setSelectedLeave] = useState(null);
  const [selectedWorkSchedule, setSelectedWorkSchedule] = useState(null);
  const [actionDialog, setActionDialog] = useState({ open: false, mode: null, row: null });
  const [detailDialogOpen, setDetailDialogOpen] = useState(false);
  const [detailLoading, setDetailLoading] = useState(false);
  const [leaveRequestDetail, setLeaveRequestDetail] = useState(null);

  const [attendTick, setAttendTick] = useState(0);
  const [leaveTick, setLeaveTick] = useState(0);
  const [requestTick, setRequestTick] = useState(0);
  const [approvalTick, setApprovalTick] = useState(0);
  const [balanceTick, setBalanceTick] = useState(0);
  const [workScheduleTick, setWorkScheduleTick] = useState(0);
  const [workScheduleRequestTick, setWorkScheduleRequestTick] = useState(0);
  const [workScheduleRequestInboxTick, setWorkScheduleRequestInboxTick] = useState(0);

  useEffect(() => {
    const fetch = async () => {
      setAttendLoading(true);
      try {
        const res = await hrAttendApi.getAttendList({
          searchYm,
          searchUsrUuid: searchUsrUuid || undefined,
        });
        setAttendList(res.data.list || []);
      } catch (e) {
        enqueueSnackbar('출퇴근 목록 조회 실패', { variant: 'error' });
      } finally {
        setAttendLoading(false);
      }
    };
    fetch();
  }, [searchYm, searchUsrUuid, attendTick]);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await hrAttendApi.getWorkShifts();
        setWorkShiftList(res.data.list || []);
      } catch (e) {
        enqueueSnackbar('근무유형 조회 실패', { variant: 'error' });
      }
    };
    fetch();
  }, []);

  useEffect(() => {
    const fetch = async () => {
      setWorkScheduleLoading(true);
      try {
        const res = await hrAttendApi.getMyWorkSchedules({ workYm: searchYm });
        setWorkScheduleList(res.data.list || []);
      } catch (e) {
        enqueueSnackbar('내 근무표 조회 실패', { variant: 'error' });
      } finally {
        setWorkScheduleLoading(false);
      }
    };
    fetch();
  }, [searchYm, workScheduleTick]);

  useEffect(() => {
    const fetch = async () => {
      setWorkScheduleRequestLoading(true);
      try {
        const res = await hrAttendApi.getMyWorkScheduleRequests({ searchYm });
        setWorkScheduleRequestList(res.data.list || []);
      } catch (e) {
        enqueueSnackbar('근무표 변경 요청 조회 실패', { variant: 'error' });
      } finally {
        setWorkScheduleRequestLoading(false);
      }
    };
    fetch();
  }, [searchYm, workScheduleRequestTick]);

  useEffect(() => {
    const fetch = async () => {
      setWorkScheduleRequestInboxLoading(true);
      try {
        const res = await hrAttendApi.getWorkScheduleRequestInbox({ searchYm });
        setWorkScheduleRequestInboxList(res.data.list || []);
      } catch (e) {
        setWorkScheduleRequestInboxList([]);
      } finally {
        setWorkScheduleRequestInboxLoading(false);
      }
    };
    fetch();
  }, [searchYm, workScheduleRequestInboxTick]);

  useEffect(() => {
    const fetch = async () => {
      setHolidayLoading(true);
      try {
        const res = await hrAttendApi.getHolidays({ searchYm });
        setHolidayList(res.data.list || []);
      } catch (e) {
        setHolidayList([]);
      } finally {
        setHolidayLoading(false);
      }
    };
    fetch();
  }, [searchYm, workScheduleTick]);

  useEffect(() => {
    const fetch = async () => {
      setLeaveLoading(true);
      try {
        const res = await hrAttendApi.getLeaveList({
          searchYm,
          searchUsrUuid: searchUsrUuid || undefined,
        });
        setLeaveList(res.data.list || []);
      } catch (e) {
        enqueueSnackbar('휴가 목록 조회 실패', { variant: 'error' });
      } finally {
        setLeaveLoading(false);
      }
    };
    fetch();
  }, [searchYm, searchUsrUuid, leaveTick]);

  useEffect(() => {
    const fetch = async () => {
      setRequestLoading(true);
      try {
        const res = await hrAttendApi.getMyLeaveRequests({ searchYm });
        setLeaveRequestList(res.data.list || []);
      } catch (e) {
        enqueueSnackbar('휴가 신청 목록 조회 실패', { variant: 'error' });
      } finally {
        setRequestLoading(false);
      }
    };
    fetch();
  }, [searchYm, requestTick]);

  useEffect(() => {
    const fetch = async () => {
      setApprovalLoading(true);
      try {
        const res = await hrAttendApi.getLeaveApprovalInbox({ searchYm });
        setApprovalInboxList(res.data.list || []);
      } catch (e) {
        enqueueSnackbar('휴가 결재함 조회 실패', { variant: 'error' });
      } finally {
        setApprovalLoading(false);
      }
    };
    fetch();
  }, [searchYm, approvalTick]);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await hrAttendApi.getAnnualLeaveBalance(dayjs().format('YYYY'));
        setBalance(res.data);
      } catch (e) {
        setBalance(null);
      }
    };
    fetch();
  }, [balanceTick]);

  const handleAttendSave = async (values) => {
    try {
      if (selectedAttend) {
        await hrAttendApi.editAttend(selectedAttend.attendUuid, values);
        enqueueSnackbar('출퇴근 정보를 수정했습니다.', { variant: 'success' });
      } else {
        await hrAttendApi.addAttend(values);
        enqueueSnackbar('출퇴근 정보를 등록했습니다.', { variant: 'success' });
      }
      setAttendModalOpen(false);
      setSelectedAttend(null);
      setAttendTick((t) => t + 1);
    } catch (e) {
      enqueueSnackbar('저장에 실패했습니다.', { variant: 'error' });
    }
  };

  const handleAttendDelete = async (attendUuid) => {
    try {
      await hrAttendApi.removeAttend(attendUuid);
      enqueueSnackbar('출퇴근 정보를 삭제했습니다.', { variant: 'success' });
      setAttendTick((t) => t + 1);
    } catch (e) {
      enqueueSnackbar('삭제에 실패했습니다.', { variant: 'error' });
    }
  };

  const handleWorkScheduleSave = async (schedules) => {
    setWorkScheduleSaving(true);
    try {
      const res = await hrAttendApi.saveMyWorkSchedules({
        workYm: searchYm,
        planStatus: 'CONFIRMED',
        schedules,
      });
      setWorkScheduleList(res.data.list || []);
      enqueueSnackbar('내 근무표를 저장했습니다.', { variant: 'success' });
      setWorkScheduleTick((t) => t + 1);
    } catch (e) {
      enqueueSnackbar(e?.response?.data?.message || '근무표 저장에 실패했습니다.', { variant: 'error' });
    } finally {
      setWorkScheduleSaving(false);
    }
  };

  const handleWorkScheduleChangeRequestSubmit = async (values) => {
    setWorkScheduleRequestSaving(true);
    try {
      await hrAttendApi.submitWorkScheduleChangeRequest(values);
      setWorkScheduleRequestModalOpen(false);
      setSelectedWorkSchedule(null);
      setWorkScheduleTick((t) => t + 1);
      setWorkScheduleRequestTick((t) => t + 1);
      setWorkScheduleRequestInboxTick((t) => t + 1);
      enqueueSnackbar('근무표 변경 요청을 등록했습니다.', { variant: 'success' });
    } catch (e) {
      enqueueSnackbar(e?.response?.data?.message || '근무표 변경 요청에 실패했습니다.', { variant: 'error' });
    } finally {
      setWorkScheduleRequestSaving(false);
    }
  };

  const handleWorkScheduleRequestCancel = async (row) => {
    if (!window.confirm('근무표 변경 요청을 취소할까요?')) return;
    setWorkScheduleRequestSaving(true);
    try {
      await hrAttendApi.cancelWorkScheduleChangeRequest(row.reqId);
      setWorkScheduleTick((t) => t + 1);
      setWorkScheduleRequestTick((t) => t + 1);
      setWorkScheduleRequestInboxTick((t) => t + 1);
      enqueueSnackbar('근무표 변경 요청을 취소했습니다.', { variant: 'success' });
    } catch (e) {
      enqueueSnackbar(e?.response?.data?.message || '근무표 변경 요청 취소에 실패했습니다.', { variant: 'error' });
    } finally {
      setWorkScheduleRequestSaving(false);
    }
  };

  const handleWorkScheduleRequestConfirm = async (row) => {
    if (!window.confirm('근무표 변경 요청을 확정할까요?')) return;
    setWorkScheduleRequestSaving(true);
    try {
      await hrAttendApi.confirmWorkScheduleChangeRequest(row.reqId);
      setWorkScheduleTick((t) => t + 1);
      setWorkScheduleRequestTick((t) => t + 1);
      setWorkScheduleRequestInboxTick((t) => t + 1);
      enqueueSnackbar('근무표 변경 요청을 확정했습니다.', { variant: 'success' });
    } catch (e) {
      enqueueSnackbar(e?.response?.data?.message || '근무표 변경 요청 확정에 실패했습니다.', { variant: 'error' });
    } finally {
      setWorkScheduleRequestSaving(false);
    }
  };

  const handleWorkScheduleRequestReject = async (row) => {
    if (!window.confirm('근무표 변경 요청을 반려할까요?')) return;
    setWorkScheduleRequestSaving(true);
    try {
      await hrAttendApi.rejectWorkScheduleChangeRequest(row.reqId);
      setWorkScheduleTick((t) => t + 1);
      setWorkScheduleRequestTick((t) => t + 1);
      setWorkScheduleRequestInboxTick((t) => t + 1);
      enqueueSnackbar('근무표 변경 요청을 반려했습니다.', { variant: 'success' });
    } catch (e) {
      enqueueSnackbar(e?.response?.data?.message || '근무표 변경 요청 반려에 실패했습니다.', { variant: 'error' });
    } finally {
      setWorkScheduleRequestSaving(false);
    }
  };

  const handleHolidaySave = async (holiday) => {
    setHolidaySaving(true);
    try {
      const res = await hrAttendApi.saveHoliday({
        ...holiday,
        searchYm,
        holidayTyp: holiday.holidayTyp || 'COMPANY',
        sourceTyp: 'MANUAL',
        useYn: 'Y',
      });
      setHolidayList(res.data.list || []);
      enqueueSnackbar('휴일을 등록했습니다.', { variant: 'success' });
    } catch (e) {
      enqueueSnackbar(e?.response?.data?.message || '휴일 등록에 실패했습니다.', { variant: 'error' });
    } finally {
      setHolidaySaving(false);
    }
  };

  const handleHolidayCollect = async () => {
    setHolidaySaving(true);
    try {
      const res = await hrAttendApi.collectHolidays({ searchYm });
      const insertedCount = res.data.insertedCount || 0;
      const updatedCount = res.data.updatedCount || 0;
      const skippedCount = res.data.skippedCount || 0;

      setHolidayList(res.data.list || []);
      setWorkScheduleTick((t) => t + 1);
      enqueueSnackbar(
        `국가공휴일 수집 완료: 신규 ${insertedCount}건, 갱신 ${updatedCount}건, 건너뜀 ${skippedCount}건`,
        { variant: 'success' },
      );
    } catch (e) {
      enqueueSnackbar(e?.response?.data?.message || '국가공휴일 수집에 실패했습니다.', { variant: 'error' });
    } finally {
      setHolidaySaving(false);
    }
  };

  const handleLeaveSave = async (values) => {
    try {
      if (selectedLeave) {
        await hrAttendApi.editLeave(selectedLeave.leaveUuid, values);
        enqueueSnackbar('휴가 정보를 수정했습니다.', { variant: 'success' });
      } else {
        await hrAttendApi.addLeave(values);
        enqueueSnackbar('휴가 정보를 등록했습니다.', { variant: 'success' });
      }
      setLeaveModalOpen(false);
      setSelectedLeave(null);
      setLeaveTick((t) => t + 1);
      setBalanceTick((t) => t + 1);
    } catch (e) {
      enqueueSnackbar('저장에 실패했습니다.', { variant: 'error' });
    }
  };

  const handleLeaveDelete = async (leaveUuid) => {
    try {
      await hrAttendApi.removeLeave(leaveUuid);
      enqueueSnackbar('휴가 정보를 삭제했습니다.', { variant: 'success' });
      setLeaveTick((t) => t + 1);
      setBalanceTick((t) => t + 1);
    } catch (e) {
      enqueueSnackbar('삭제에 실패했습니다.', { variant: 'error' });
    }
  };

  const handleLeaveRequestSave = async (values) => {
    try {
      await hrAttendApi.submitLeaveRequest(values);
      enqueueSnackbar('휴가 신청을 상신했습니다.', { variant: 'success' });
      setLeaveRequestModalOpen(false);
      setRequestTick((t) => t + 1);
      setApprovalTick((t) => t + 1);
    } catch (e) {
      enqueueSnackbar(e?.response?.data?.message || '휴가 신청 상신에 실패했습니다.', { variant: 'error' });
    }
  };

  const handleLeaveRequestRecall = async (leaveReqId) => {
    try {
      await hrAttendApi.recallLeaveRequest(leaveReqId);
      enqueueSnackbar('휴가 신청을 회수했습니다.', { variant: 'success' });
      setRequestTick((t) => t + 1);
      setApprovalTick((t) => t + 1);
    } catch (e) {
      enqueueSnackbar(e?.response?.data?.message || '회수에 실패했습니다.', { variant: 'error' });
    }
  };

  const handleLeaveApprovalAction = async (comment) => {
    try {
      if (actionDialog.mode === 'APPROVE') {
        await hrAttendApi.approveLeaveRequest(actionDialog.row.leaveReqId, { rmk: comment });
        enqueueSnackbar('휴가 신청을 승인했습니다.', { variant: 'success' });
      } else {
        await hrAttendApi.rejectLeaveRequest(actionDialog.row.leaveReqId, { rmk: comment });
        enqueueSnackbar('휴가 신청을 반려했습니다.', { variant: 'success' });
      }
      setActionDialog({ open: false, mode: null, row: null });
      setApprovalTick((t) => t + 1);
      setRequestTick((t) => t + 1);
      setLeaveTick((t) => t + 1);
      setBalanceTick((t) => t + 1);
    } catch (e) {
      enqueueSnackbar(e?.response?.data?.message || '결재 처리에 실패했습니다.', { variant: 'error' });
    }
  };

  const handleOpenLeaveRequestDetail = async (row) => {
    setDetailDialogOpen(true);
    setDetailLoading(true);
    try {
      const res = await hrAttendApi.getLeaveRequest(row.leaveReqId);
      setLeaveRequestDetail({
        info: res.data.info,
        steps: res.data.steps || [],
      });
    } catch (e) {
      enqueueSnackbar(e?.response?.data?.message || '휴가 신청 상세 조회에 실패했습니다.', { variant: 'error' });
      setDetailDialogOpen(false);
      setLeaveRequestDetail(null);
    } finally {
      setDetailLoading(false);
    }
  };

  const handleCloseLeaveRequestDetail = () => {
    setDetailDialogOpen(false);
    setLeaveRequestDetail(null);

    if (location.search) {
      navigate(location.pathname, { replace: true });
    }
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const targetTab = searchParams.get('tab');
    const leaveReqId = searchParams.get('leaveReqId');
    const action = searchParams.get('action');

    if (targetTab === 'attend') {
      setTabIndex(0);
    } else if (targetTab === 'work') {
      setTabIndex(1);
    } else if (targetTab === 'work-requests') {
      setTabIndex(2);
    } else if (targetTab === 'work-inbox') {
      setTabIndex(3);
    } else if (targetTab === 'my') {
      setTabIndex(4);
    } else if (targetTab === 'inbox') {
      setTabIndex(5);
    } else if (targetTab === 'ledger') {
      setTabIndex(6);
    }

    if (leaveReqId) {
      handleOpenLeaveRequestDetail({ leaveReqId });
    }

    if (targetTab === 'my' && action === 'request') {
      setLeaveRequestModalOpen(true);
      navigate(`${location.pathname}?tab=my`, { replace: true });
    }
  }, [location.search]);

  return (
    <Box sx={{ p: 3 }}>
      <BreadcrumbsContainer title="환경설정/근태관리" />

      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 1 }}>
        <Typography variant="h5" fontWeight={700}>근태 관리</Typography>
        <Chip
          label={`${searchYm.slice(0, 4)}년 ${parseInt(searchYm.slice(4), 10)}월`}
          size="small"
          color="primary"
          variant="outlined"
        />
        {balance && (
          <Chip
            label={`내 연차 잔여 ${balance.balanceDays}일 (부여 ${balance.grantDays}일 / 사용 ${balance.usedDays}일)`}
            size="small"
            color="success"
            variant="outlined"
          />
        )}
      </Box>

      <Tabs value={tabIndex} onChange={(_, v) => setTabIndex(v)} sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}>
        <Tab label={`출퇴근 관리 (${attendList.length})`} />
        <Tab label={`내 근무표 (${workScheduleList.length})`} />
        <Tab label={`근무 변경 요청 (${workScheduleRequestList.length})`} />
        <Tab label={`근무 변경 승인 (${workScheduleRequestInboxList.length})`} />
        <Tab label={`내 휴가 신청 (${leaveRequestList.length})`} />
        <Tab label={`휴가 결재함 (${approvalInboxList.length})`} />
        <Tab label={`확정 휴가/근태 (${leaveList.length})`} />
      </Tabs>

      {tabIndex === 0 && (
        <AttendListTab
          list={attendList}
          loading={attendLoading}
          searchYm={searchYm}
          searchUsrUuid={searchUsrUuid}
          onSearchYmChange={setSearchYm}
          onSearchUsrChange={setSearchUsrUuid}
          onAdd={() => {
            setSelectedAttend(null);
            setAttendModalOpen(true);
          }}
          onEdit={(row) => {
            setSelectedAttend(row);
            setAttendModalOpen(true);
          }}
          onDelete={handleAttendDelete}
        />
      )}

      {tabIndex === 1 && (
        <WorkScheduleTab
          list={workScheduleList}
          shifts={workShiftList}
          holidays={holidayList}
          loading={workScheduleLoading || holidayLoading}
          saving={workScheduleSaving || holidaySaving}
          searchYm={searchYm}
          onSearchYmChange={setSearchYm}
          onSave={handleWorkScheduleSave}
          onHolidaySave={handleHolidaySave}
          onHolidayCollect={handleHolidayCollect}
          onChangeRequest={(row) => {
            setSelectedWorkSchedule(row);
            setWorkScheduleRequestModalOpen(true);
          }}
        />
      )}

      {tabIndex === 2 && (
        <WorkScheduleRequestListTab
          list={workScheduleRequestList}
          loading={workScheduleRequestLoading || workScheduleRequestSaving}
          searchYm={searchYm}
          mode="my"
          onSearchYmChange={setSearchYm}
          onCancel={handleWorkScheduleRequestCancel}
        />
      )}

      {tabIndex === 3 && (
        <WorkScheduleRequestListTab
          list={workScheduleRequestInboxList}
          loading={workScheduleRequestInboxLoading || workScheduleRequestSaving}
          searchYm={searchYm}
          mode="inbox"
          onSearchYmChange={setSearchYm}
          onConfirm={handleWorkScheduleRequestConfirm}
          onReject={handleWorkScheduleRequestReject}
        />
      )}

      {tabIndex === 4 && (
        <LeaveRequestListTab
          list={leaveRequestList}
          loading={requestLoading}
          searchYm={searchYm}
          onSearchYmChange={setSearchYm}
          onAdd={() => setLeaveRequestModalOpen(true)}
          onRecall={handleLeaveRequestRecall}
          onRowClick={handleOpenLeaveRequestDetail}
        />
      )}

      {tabIndex === 5 && (
        <LeaveApprovalInboxTab
          list={approvalInboxList}
          loading={approvalLoading}
          searchYm={searchYm}
          onSearchYmChange={setSearchYm}
          onApprove={(row) => setActionDialog({ open: true, mode: 'APPROVE', row })}
          onReject={(row) => setActionDialog({ open: true, mode: 'REJECT', row })}
          onRowClick={handleOpenLeaveRequestDetail}
        />
      )}

      {tabIndex === 6 && (
        <LeaveListTab
          list={leaveList}
          loading={leaveLoading}
          searchYm={searchYm}
          searchUsrUuid={searchUsrUuid}
          onSearchYmChange={setSearchYm}
          onSearchUsrChange={setSearchUsrUuid}
          onAdd={() => {
            setSelectedLeave(null);
            setLeaveModalOpen(true);
          }}
          onEdit={(row) => {
            setSelectedLeave(row);
            setLeaveModalOpen(true);
          }}
          onDelete={handleLeaveDelete}
        />
      )}

      <AttendInputModal
        open={attendModalOpen}
        data={selectedAttend}
        onClose={() => {
          setAttendModalOpen(false);
          setSelectedAttend(null);
        }}
        onSave={handleAttendSave}
      />

      <LeaveInputModal
        open={leaveModalOpen}
        data={selectedLeave}
        onClose={() => {
          setLeaveModalOpen(false);
          setSelectedLeave(null);
        }}
        onSave={handleLeaveSave}
      />

      <WorkScheduleChangeRequestDialog
        open={workScheduleRequestModalOpen}
        row={selectedWorkSchedule}
        shifts={workShiftList}
        saving={workScheduleRequestSaving}
        onClose={() => {
          setWorkScheduleRequestModalOpen(false);
          setSelectedWorkSchedule(null);
        }}
        onSubmit={handleWorkScheduleChangeRequestSubmit}
      />

      <LeaveRequestModal
        open={leaveRequestModalOpen}
        onClose={() => setLeaveRequestModalOpen(false)}
        onSave={handleLeaveRequestSave}
        balance={balance}
      />

      <LeaveRequestActionDialog
        open={actionDialog.open}
        mode={actionDialog.mode}
        row={actionDialog.row}
        onClose={() => setActionDialog({ open: false, mode: null, row: null })}
        onConfirm={handleLeaveApprovalAction}
      />

      <LeaveRequestDetailDialog
        open={detailDialogOpen}
        loading={detailLoading}
        detail={leaveRequestDetail}
        onClose={handleCloseLeaveRequestDetail}
      />
    </Box>
  );
};

export default AttendMngContainer;
